<div class="login-form">
    <h2 mat-dialog-title>Login to RestoreID</h2>
    <mat-dialog-content [formGroup]="loginForm" class="login-content">
      <mat-form-field>
        <input matInput placeholder="Login/Email" formControlName="loginInfo" required autocomplete="off">
        <mat-error>{{ getErrorMessage(loginInfoControl) }}</mat-error>
      </mat-form-field>

      <mat-form-field>
        <input matInput type="password" placeholder="Password" formControlName="password" required>
        <mat-error>{{ getErrorMessage(passwordControl) }}</mat-error>
      </mat-form-field>
    </mat-dialog-content>

    <mat-dialog-actions class="login-action">
      <button mat-raised-button mat-dialog-close>Cancel</button>
      
      <button mat-raised-button color="primary" [disabled]="loginForm.invalid" (click)="submitLogin()">Login</button>
    </mat-dialog-actions>
</div>
